import React, { useState } from "react";
import "./ImageSlider.css";
import CmsHelper from "../../../Utilities/CmsHelpers";

function ImageSlider({ images, activeIndex: controlledIndex, onChange }) {
  let slides = [];

  images.forEach((img, index) => {
    slides.push({ src: CmsHelper.getImagePath(img) })
  });

  const [uncontrolledIndex, setUncontrolledIndex] = useState(0);
  const isControlled = controlledIndex !== undefined && typeof onChange === "function";
  const activeIndex = isControlled ? controlledIndex : uncontrolledIndex;

  const changeImage = (index) => {
    if (isControlled) {
      onChange(index);
    } else {
      setUncontrolledIndex(index);
    }
  };
  return (
    <div className="ant-image-slider">
      {slides.map((slide, index) => (
        <div
          className={`${index === activeIndex ? "active" : ""}`}
          style={{
            left: `${(index+1) * -20}px`,
            zIndex: `${index === activeIndex ? slides.length : slides.length-index}`,
            backgroundImage: ` ${index !== activeIndex
              ? "linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),"
              : ""
              } url("${slide.src}")`,
          }}
          key={index}
          onClick={() => changeImage(index)}
        ></div>
        // <img src={slide.src} alt={`slide-image ${index}`} key={index} />
      ))}
    </div>
  );
}

export default ImageSlider;
